import { clipboard } from '@gitbook/spine-react';

import { toHtmlLinkDocument } from './toHtmlLinkDocument';
import { toMarkdownLink } from './toMarkdownLink';

/**
 * Copies a title as a link (both markdown and HTML formats) to the clipboard.
 */
export function copyTitleAsLink(
    title: string,
    url: string,
    options?: {
        notify?: { title: string };
    }
): void {
    clipboard.writeData(
        {
            'text/plain': toMarkdownLink(title, url),
            'text/html': toHtmlLinkDocument(title, url),
        },
        {
            notify: options?.notify ?? { title: 'Title copied in clipboard' },
        }
    );
}
